import { render, staticRenderFns } from "./registerLoginReset.vue?vue&type=template&id=04429d2a&scoped=true&"
import script from "./registerLoginReset.vue?vue&type=script&lang=js&"
export * from "./registerLoginReset.vue?vue&type=script&lang=js&"
import style0 from "./registerLoginReset.vue?vue&type=style&index=0&lang=css&"
import style1 from "./registerLoginReset.vue?vue&type=style&index=1&id=04429d2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04429d2a",
  null
  
)

export default component.exports